import { Box, Button, Flex, Text } from "@radix-ui/themes";
import { Link } from "react-router-dom";

import { Path } from "~/v2/path";
import { AccountSwitcher } from "~/v3-poc/features/account-switcher";
import { HeaderPortfolioMetrics } from "~/v3-poc/features/header-metrics";
import { MarketStatusPill } from "~/v3-poc/features/market-status";
import { Logo } from "./Logo";

export const Header = () => {
  return (
    <Box
      asChild
      px="4"
      py="3"
      className="border-[color:var(--gray-a5)] border-b [background-color:var(--color-panel-solid)]"
    >
      <header>
        <Flex align="center" justify="between" gap="4" wrap="wrap">
          <Flex align="center" gap="3">
            <Link to={Path.ROUTE_DASHBOARD} aria-label="Alpaca home">
              <Logo />
            </Link>
            <Text size="2" weight="bold" trim="both">
              Alpaca One
            </Text>
            <AccountSwitcher />
            <MarketStatusPill />
          </Flex>
          <Flex align="center" justify="end" gap="4" flexGrow="1" wrap="wrap">
            <HeaderPortfolioMetrics />
            <Button asChild size="1" variant="soft" color="gray">
              <Link to={Path.ROUTE_DASHBOARD}>Classic view</Link>
            </Button>
          </Flex>
        </Flex>
      </header>
    </Box>
  );
};
